import React from "react";
import { BrowserRouter as Router } from "react-router-dom";

import Layouts from "./components/layout/Layouts";

import AuthState from "./context/authentication/authState";
import AlertState from "./context/alert/alertState";
import ModalState from "./context/modal/modalState";
import TableState from "./context/table/tableState";
import PortalState from "./context/portal/portalState";
import ReceiverState from './context/receiver/ReceiverState'
import BillState from './context/bill/BillState'

function App() {
  return (
    <ModalState>
      <AlertState>
        <AuthState>
            <ReceiverState>
                <BillState>
              <PortalState>
                <TableState>
                  <Router>
                    <Layouts />
                  </Router>
                </TableState>
              </PortalState>
              </BillState>

            </ReceiverState>
        </AuthState>
      </AlertState>
    </ModalState>
  );
}

export default App;
